import _ from 'lodash';
import { log, Member } from '@swiper/core';
import { DataFilesService } from './DataFilesService';
import path from 'path';
import globby from 'globby';
import globToRegexp from 'glob-to-regexp';
import Promise from 'bluebird';
import config from '~/config';

export class MembersService extends DataFilesService {

  get name() { return 'members'; }

  async getMemberIdsForMembership( membershipId ) {
    const files = await globby( this.pathto( `${membershipId}.*.json` ) );
    return _.map( files, file => path.basename( file, '.json' ) );
  }

  getMembership( id ) {
    return this.app.service( 'memberships' ).get( id );
  }

  async get( id, params ) {
    const data = await super.get( id, params );

    const membership = await this.getMembership( data.membershipId );
    log.debug( 'MEMBERSHIP---', membership );
    data.flags = this.processFlags(
      _.get( config, [ 'memberships', 'types', membership.type, 'flags' ] ),
      membership.flags,
      _.get( config, [ 'members', 'types', data.type, 'flags' ] ),
      data.flags,
    );
    data.settings = this.processSettings(
      _.get( config, [ 'memberships', 'types', membership.type, 'settings' ] ),
      membership.settings,
      _.get( config, [ 'members', 'types', data.type, 'settings' ] ),
      data.settings,
    );
    log.debug( 'M/M', membership, data );
    return new Member( data );
  }

  async find( { query, ...params } ) {
    log.debug( 'MembersService#find', query, params );
    const keys = _.keys( query );
    console.log( 'FIND KEYS', keys );
    if ( keys.length === 1 ) {
      const key = keys[0];
      if ( key === 'membershipId' ) {
        // This is a shortcut for finding all the members for a given
        // membershipId without having to query them all.
        const ids = await this.getMemberIdsForMembership( query.membershipId );
        log.debug( 'IDS', ids );
        return Promise.map( ids, id => this.get( id ) );
      } else if ( key === 'name' && query.name.includes( '*' ) ) {
        // Searching for someone by name
        const re = globToRegexp( query.name, { flags : 'i' } );
        // TODO - Config
        const nameFields = [ 'name', 'firstName', 'lastName', 'displayName' ];
        const matcher = rec => {
          for ( const f of nameFields ) {
            if ( ! _.isString( rec[ f ] ) ) continue;
            if ( re.test( rec[ f ] ) ) return true;
          }
          return false;
        };
        return super.filter( matcher );
      }
    }
    return super.find( { query, ...params } );
  }

  processFlags( ...flags ) {
    const all = _.uniq( _.compact( _.flattenDeep( flags ) ) );
    const exclude = _.filter( all, x => x.startsWith( '-' ) )
      .map( x => x.slice( 1 ) );
    const include = _.filter( all, x => ! x.startsWith( '-' ) );
    return _.difference( include, exclude );
  }

  processSettings( ...settings ) {
    return _.assign( {}, ...settings );
  }

}

export const hooks = {
  before  : {
    all     : [ 'auth' ],
    create  : [ 'hash_password' ],
  },
  after   : [ 'protect_password' ],
};
